var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-apex-charts',{attrs:{"type":"donut","height":"350","options":_vm.apexChatData.donutChart.chartOptions,"series":_vm.apexChatData.donutChart.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }